/*
 * Pestaña "Visitas" de la ficha de tienda IGI: historial de visitas (mas reciente primero), con
 * progreso del checklist (n/9), acciones y compromisos pendientes, y botones Editar/Imprimir
 * acta/Borrar. "+ Nueva visita" y "Editar"/"Borrar" solo si `puedeVisitar` (igi_create_visit) y la
 * visita es propia (`puede_editar` que ya viene calculado del backend).
 */
import React from "react";
import Button from "../../../../components/button";
import {formatoFecha} from "../niveles";

const CHECKLIST_CLAVES = [
    "visito", "reviso_resultados", "ejecuto_activacion", "feedback", "reconocio",
    "detecto_brecha", "dejo_tareas", "pidio_evidencia", "seguimiento_ant",
];

const progreso = (checklist) => CHECKLIST_CLAVES.filter((clave) => checklist[clave]).length;

const Visitas = ({visitas, puedeVisitar, onNueva, onEditar, onBorrar, onImprimir}) => (
    <div>
        {puedeVisitar && (
            <Button
                type="button"
                theme="primary"
                classes="mb-1"
                text={<><i className="bx bx-plus"/> Nueva visita</>}
                onChange={onNueva}
            />
        )}
        {visitas.length === 0 && (
            <div className="alert alert-info">La tienda todavía no tiene visitas registradas.</div>
        )}
        {visitas.map((v) => {
            const pendientesAcciones = v.acciones.filter((a) => a.estado !== "Completado").length;
            const pendientesCompromisos = v.compromisos.filter((c) => c.estado !== "Hecho").length;
            return (
                <div key={v.id} className="card mb-1">
                    <div className="card-body p-1">
                        <div className="d-flex justify-content-between align-items-start flex-wrap">
                            <div>
                                <strong>{formatoFecha(v.fecha)}</strong>{" "}
                                {v.hora_inicio && (
                                    <span className="small text-muted">
                                        {v.hora_inicio}{v.hora_fin ? ` – ${v.hora_fin}` : ""}
                                    </span>
                                )}
                                <div className="small text-muted">{v.autor.nombres || v.autor.usuario}</div>
                            </div>
                            <div>
                                <span className="badge badge-light mr-25">✓ {progreso(v.checklist)}/9</span>
                                {pendientesAcciones > 0 && (
                                    <span className="badge badge-warning mr-25">⏳ {pendientesAcciones} acc.</span>
                                )}
                                {pendientesCompromisos > 0 && (
                                    <span className="badge badge-danger">🔴 {pendientesCompromisos} comp.</span>
                                )}
                            </div>
                        </div>
                        <div className="d-flex mt-50 flex-wrap">
                            <Button
                                type="button"
                                theme="light"
                                classes="btn-sm mr-50 mb-50"
                                text={<><i className="bx bx-printer"/> Imprimir acta</>}
                                onChange={() => onImprimir(v)}
                            />
                            {v.puede_editar && (
                                <>
                                    <Button
                                        type="button"
                                        theme="warning"
                                        classes="btn-sm mr-50 mb-50"
                                        text={<><i className="bx bx-edit"/> Editar</>}
                                        onChange={() => onEditar(v)}
                                    />
                                    <Button
                                        type="button"
                                        theme="danger"
                                        classes="btn-sm mb-50"
                                        text={<><i className="bx bx-trash"/> Borrar</>}
                                        onChange={() => onBorrar(v)}
                                    />
                                </>
                            )}
                        </div>
                    </div>
                </div>
            );
        })}
    </div>
);

export default Visitas;
